import type { FunctionComponent } from "react";

import {
  Checkmark,
  Label,
  LabelText,
  StyledInput,
} from "scmp-app/components/posties/quiz/quiz-answer/styles";
import type { Answers } from "scmp-app/components/posties/quiz/types";

type Props = {
  answer: Answers;
  correctAnswer: null | string[];
  isCorrect: boolean | null;
  onValueChange: (value: string[]) => void;
  selectedAnswer: null | string[];
};
export const PostiesQuizCheckbox: FunctionComponent<Props> = ({
  answer,
  correctAnswer,
  isCorrect,
  onValueChange,
  selectedAnswer,
}) => {
  const handleCheckboxChange = () => {
    const newSelectedAnswer = selectedAnswer ? [...selectedAnswer] : [];
    if (newSelectedAnswer.includes(answer.documentId)) {
      newSelectedAnswer.splice(newSelectedAnswer.indexOf(answer.documentId), 1);
    } else {
      newSelectedAnswer.push(answer.documentId);
    }
    onValueChange(newSelectedAnswer);
  };

  const getAnswerStatus = () => {
    if (isCorrect === null) {
      return null;
    }

    if (correctAnswer && correctAnswer.includes(answer.documentId)) {
      return true;
    } else if (selectedAnswer && selectedAnswer.includes(answer.documentId)) {
      return false;
    }

    return null;
  };

  return (
    <Label
      $isCorrect={getAnswerStatus()}
      $selected={selectedAnswer?.includes(answer.documentId) ?? false}
      $type="multiple_choice"
    >
      <StyledInput
        checked={selectedAnswer?.includes(answer.documentId)}
        disabled={isCorrect !== null}
        onChange={() => handleCheckboxChange()}
        type="checkbox"
        value={answer.documentId}
      />
      <Checkmark $type="multiple_choice" />
      <LabelText>{answer.value}</LabelText>
    </Label>
  );
};

PostiesQuizCheckbox.displayName = "PostiesQuizCheckbox";
